var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49C158"
    },
    d: "M226.203,413.74l-62.74-62.967c-6.901-6.925-6.881-18.135,0.045-25.035l194.099-193.36 c6.925-6.901,18.135-6.881,25.035,0.045l62.74,62.967c6.901,6.925,6.88,18.135-0.045,25.035l-194.099,193.36 C244.313,420.686,233.104,420.666,226.203,413.74z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.087,
    y: 218.963,
    transform: "matrix(-0.7058 -0.7084 0.7084 -0.7058 339.8446 675.7344)",
    style: {
      fill: "#F5BA3D"
    },
    width: 124.297,
    height: 96.673
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.604,
    y: 287.191,
    transform: "matrix(-0.7058 -0.7084 0.7084 -0.7058 174.6924 743.6041)",
    style: {
      fill: "#E44F50"
    },
    width: 124.297,
    height: 96.673
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F2F2"
    },
    d: "M163.658,325.631L70.136,418.79c-6.925,6.901-6.947,18.11-0.045,25.035l62.74,62.967 c6.901,6.925,18.11,6.945,25.035,0.045l93.522-93.158L163.658,325.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D3D4"
    },
    d: "M185.043,475.165l38.11-89.821l-59.497-59.713l-93.512,93.175c-6.925,6.901-6.947,18.11-0.045,25.035 l8.375,8.404l79.649,33.799C168.56,490.474,180.614,485.604,185.043,475.165z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DDA23A"
    },
    points: "300.619,189.16 232.137,257.395 263.91,289.284 304.667,193.223 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C9474D"
    },
    points: "263.91,289.284 232.137,257.395 163.655,325.631 223.152,385.343 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69539C"
    },
    d: "M185.752,125.82l36.28-85.498c3.819-9,14.212-13.2,23.212-9.381l81.826,34.722 c9,3.819,13.2,14.212,9.381,23.212L221.435,359.44c-3.819,9-14.212,13.2-23.212,9.381l-75.044-31.844"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#584987"
    },
    points: "197.809,97.409 185.752,125.82 185.752,302.436 197.809,302.436 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F2F2"
    },
    d: "M115.088,292.365l-51.566,121.52c-3.819,9,0.381,19.393,9.381,23.212l81.826,34.722 c9,3.819,19.393-0.381,23.212-9.381l51.566-121.52L115.088,292.365L115.088,292.365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E44F50"
    },
    d: "M168.049,313.749H79.161c-9.777,0-17.703-7.926-17.703-17.703V17.703C61.458,7.926,69.384,0,79.161,0 h88.888c9.777,0,17.703,7.926,17.703,17.703v278.343C185.752,305.823,177.827,313.749,168.049,313.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD263D"
    },
    d: "M168.049,0h-39.241c9.777,0,17.703,7.926,17.703,17.703v405.804c0,9.777-7.926,17.703-17.703,17.703 h39.241c9.777,0,17.703-7.926,17.703-17.703V17.703C185.752,7.926,177.827,0,168.049,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.781,
    y: 134.806,
    transform: "matrix(-0.9206 -0.3906 0.3906 -0.9206 368.1266 441.1534)",
    style: {
      fill: "#B378DD"
    },
    width: 124.291,
    height: 96.669
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9B6CC4"
    },
    points: "185.752,217.337 197.809,222.453 197.809,117.435 190.607,114.379 185.752,125.82 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.454,
    y: 98.157,
    style: {
      fill: "#F5BA3D"
    },
    width: 124.298,
    height: 96.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.025,
    y: 223.794,
    transform: "matrix(-0.9206 -0.3906 0.3906 -0.9206 260.8541 597.3121)",
    style: {
      fill: "#F871FF"
    },
    width: 124.291,
    height: 96.669
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D263DB"
    },
    points: "185.752,322.355 197.809,327.47 197.809,222.453 185.752,217.337 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.454,
    y: 194.826,
    style: {
      fill: "#588EED"
    },
    width: 124.298,
    height: 96.674
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D3D4"
    },
    d: "M176.672,455.731c11.673,0,21.137-9.464,21.137-21.137V327.466l-82.721-35.102L63.522,413.885 c-2.389,5.628-1.64,11.801,1.456,16.57c-0.242,4.813,1.45,9.705,5.12,13.387l11.847,11.889H176.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCBEC0"
    },
    d: "M180.973,455.291c9.61-1.987,16.835-10.498,16.835-20.697v-18.976L180.973,455.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F2F2"
    },
    d: "M61.458,291.499v132.008c0,9.777,7.926,17.703,17.703,17.703h88.888 c9.777,0,17.703-7.926,17.703-17.703V291.499H61.458z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.511,
    y: 98.157,
    style: {
      fill: "#EF9325"
    },
    width: 39.241,
    height: 96.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.511,
    y: 194.826,
    style: {
      fill: "#447BCC"
    },
    width: 39.241,
    height: 96.674
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E7E8"
    },
    d: "M146.511,423.507c0,9.777-7.926,17.703-17.703,17.703h39.241c9.777,0,17.703-7.926,17.703-17.703 V291.499h-39.241V423.507z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#58595B"
    },
    cx: 104.508,
    cy: 396.06,
    r: 16.733
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#58595B"
    },
    cx: 93.214,
    cy: 321.909,
    r: 8.851
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#58595B"
    },
    cx: 123.603,
    cy: 321.909,
    r: 8.851
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#58595B"
    },
    cx: 153.403,
    cy: 321.909,
    r: 8.851
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.83f0ad3dcfdfde797b54c8cb719fc564.svg";
export { ForwardRef as ReactComponent };